import SvgIcon from '@mui/material/SvgIcon';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { Button } from 'common/components/Buttons/Button.tsx';
import { useState } from 'react';
import { SxProps } from '@mui/system';
import PlaylistRemoveOutlinedIcon from '@mui/icons-material/PlaylistRemoveOutlined';
import { useDownloadSummaryReport } from '../Hooks/useDownloadSummaryReport.ts';
import { SummaryReportSnackbar } from './SummaryReportSnackbar.tsx';
import { SummaryReportDialog } from './SummaryReportDialog.tsx';
import RefreshAnimationIcon from 'assets/images/Refetch/RefreshAnimationIcon.svg';

const container: SxProps = {
  minWidth: 'fit-content',
};

export const SummaryReportButton = () => {
  const { t } = useTranslation();
  const {
    mutate: downloadSummaryReport,
    isPending,
    message,
    setMessage,
  } = useDownloadSummaryReport();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDownloadReport = (date: string) => {
    downloadSummaryReport(date);
    setIsModalOpen(false);
  };

  return (
    <Box sx={container}>
      <Button
        iconStart={
          isPending ? (
            <Box
              sx={{
                transform: 'scale(0.83)',
                mt: -1,
                ml: 1,
              }}
            >
              <SvgIcon
                sx={{
                  animation: `spin 1s linear infinite`,
                }}
              >
                <RefreshAnimationIcon />
              </SvgIcon>
            </Box>
          ) : (
            <SvgIcon>
              <PlaylistRemoveOutlinedIcon />
            </SvgIcon>
          )
        }
        variant="secondary"
        onClick={() => setIsModalOpen(true)}
        size="medium"
        disabled={isPending}
      >
        {t('bulkProvisioning.errorReportButton')}
      </Button>
      <SummaryReportDialog
        isOpen={isModalOpen}
        disabled={isPending}
        onClose={() => setIsModalOpen(false)}
        onDownloadReport={handleDownloadReport}
      />
      <SummaryReportSnackbar message={message} setMessage={setMessage} />
    </Box>
  );
};
